/*
 * SCOOTERRIDE — Grid Reveal Observer
 * Triggert die Stagger-Reveal-Animation auf Product-Grids erst wenn die Section
 * tatsächlich in den Viewport scrollt — nicht bei page-load.
 *
 * Wirkt auf:
 *   .section-resource-list  (product-list Section)
 *   .section-main-collection (main-collection Section)
 *
 * Setzt Klasse `is-grid-revealed` auf die Section sobald sichtbar.
 * CSS in base.css nutzt diese Klasse als Trigger.
 */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (!('IntersectionObserver' in window)) {
    // Fallback: reveal immediately
    document.querySelectorAll('.section-resource-list, .section-main-collection').forEach(function (s) {
      s.classList.add('is-grid-revealed');
    });
    return;
  }

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) {
    document.querySelectorAll('.section-resource-list, .section-main-collection').forEach(function (s) {
      s.classList.add('is-grid-revealed');
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio >= 0.18) {
        entry.target.classList.add('is-grid-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: [0, 0.1, 0.18, 0.4], rootMargin: '0px 0px -12% 0px' });

  function init() {
    var sections = document.querySelectorAll('.section-resource-list:not([data-grid-bound]), .section-main-collection:not([data-grid-bound])');
    sections.forEach(function (s) {
      s.setAttribute('data-grid-bound', '1');
      io.observe(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor hot-reload
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
